export default __webpack_public_path__ + "static/ProximaNova-7614b0e87b12684a90d46626db353b69.woff2";